import { Button, Dialog } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";

import { CheckupExistsAppointment } from "../../api/fetchScheduling";
import { formatDateTimeWithTimezone } from "../../utils/dateUtils";

interface IActiveAppointmentDialogProps {
  show: boolean;
  chassis?: string;
  appointment?: CheckupExistsAppointment;
  onClose: () => void;
}

const formatUtcDateTimeLabel = (value?: string) => {
  if (!value) return "-";
  return formatDateTimeWithTimezone(value);
};

const formatAppointmentDateLabel = (value?: string, locale?: string) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(locale || "pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const ActiveAppointmentDialog = ({
  show,
  chassis,
  appointment,
  onClose,
}: IActiveAppointmentDialogProps) => {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id: `intl-msg:appointment.step1.${id}` });

  return (
    <Dialog
      show={show}
      title={
        <span className="display-flex align-items-start">
          <span className="rioglyph rioglyph-warning-sign margin-right-14 text-color-warning" />
          <span>{t("activeAppointmentTitle")}</span>
        </span>
      }
      body={
        <div className="display-flex flex-column gap-10">
          <p className="margin-bottom-10">
            {t("chassisLabel")}: {chassis || "-"}
          </p>
          <p className="margin-bottom-10">
            {t("userLabel")}: {appointment?.creatorUserName || "-"}
          </p>
          <p className="margin-bottom-10">
            {t("dealershipLabel")}: {[appointment?.dealership?.dn, appointment?.dealership?.name].filter(Boolean).join(" - ") || "-"}
          </p>
          <p className="margin-bottom-10">
            {t("createdAtLabel")}: {formatUtcDateTimeLabel(appointment?.createdAt)}
          </p>
          <p className="margin-bottom-0">
            {t("appointmentDateLabel")}: {formatAppointmentDateLabel(appointment?.appointmentDate, intl.locale)}
          </p>
        </div>
      }
      footer={
        <div className="display-flex justify-content-end">
          <Button bsStyle="primary" onClick={onClose}>
            {t("close")}
          </Button>
        </div>
      }
      bsSize={Dialog.SIZE_SM}
      onClose={onClose}
    />
  );
};

export default ActiveAppointmentDialog;
